<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="400"
      transition="dialog-transition"
    >
      <v-sheet>
        <v-toolbar dark class="primary">
          <v-btn
            icon
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Descarga de subsidio</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <date-picker
            v-model="fecha"
            label="Fecha"
            max-today
          ></date-picker>
          <month-picker
            v-model="periodo"
            readonly
          ></month-picker>
          <v-text-field
            :value="precio | formatToTwoDecimals"
            readonly
            label="Precio"
            prepend-icon="mdi-currency-usd"
            color="primary"
          ></v-text-field>
          <v-divider></v-divider>
          <v-text-field
            v-model="glosa"
            :disabled="!(precioId > 0)"
            label="Observaciones"
            color="primary"
            prepend-icon="mdi-text"
            @keydown.enter="onSubmit"
          ></v-text-field>
          <v-text-field
            v-model="cantidad"
            :disabled="!(precioId > 0)"
            label="Kilos"
            prepend-icon="mdi-weight-kilogram"
            color="primary"
            type="number"
            :rules="rules.cantidad"
            @keydown.enter="onSubmit"
            @input="handleInputKilos"
          ></v-text-field>
          <!-- <v-text-field
            v-model="importe"
            :disabled="!(precioId > 0)"
            label="Importe"
            prepend-icon="mdi-currency-usd"
            color="primary"
            type="number"
            @keydown.enter="onSubmit"
            @input="handleInputImporte"
          ></v-text-field> -->
          <importe-input
            :value="importe"
            :disabled="!(precioId > 0) || isSubmitting"
            @input="onInput"
            @enter="onSubmit"
          ></importe-input>
          <v-footer>
            <v-btn
              :disabled="!updatable && !$can('creditos_subsidio.store')"
              color="primary"
              @click="onSubmit"
              :loading="loading"
              block
            >
              Registrar
            </v-btn>
          </v-footer>
        </v-container>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PeriodoMixin from '@/mixins/Periodo';
import MonthPicker from '@/components/MonthPicker'
import DatePicker from '@/components/DateInput'
import PrecioMixin from '@/mixins/Precios'
import ImporteInput from '@/components/ImporteInput'
export default {
  name: 'CreditosSubsidioCreateComponent',
  mixins: [PeriodoMixin, PrecioMixin],
  components: {
    'date-picker': DatePicker,
    'month-picker': MonthPicker,
    'importe-input': ImporteInput
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: Boolean
  },
  data () {
    return {
      hoy: null,
      importe: 0,
      precio: 0,
      isSubmitting: false,
    }
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    this.onLimpiar()
  },

  mounted () {
    this.cuentaId = this.selectedId
    this.hoy = this.$moment().format('YYYY-MM-DD')
    // if(this.cantidad > 0 && this.precio > 0) {
    //   this.cantidad * this.precio;
    // }
  },
  computed: {
    ...mapGetters('Cuentas', ['selectedId', 'subsidioInvierno', 'subsidioVerano']),
    ...mapGetters('Bonos', ['edited', 'rules', 'loading', 'updatable']),
    ...mapGetters('Parametros', ['vigenciaInvierno', 'vigenciaVerano']),
    dialog: {
      get () {
        return this.selected
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    saldo () {
      return this.$store.getters['Saldos/selected']
    },
    fecha: {
      get () {
        return this.edited.fecha
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          fecha: value
        })
      }
    },
    periodo: {
      get () {
        return this.edited.periodo
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          periodo: value
        })
      }
    },
    cantidad: {
      get () {
        return this.edited.cantidad
      },
      set (value) {
        const aux = value ? parseFloat(value) : 0
        this.setEdited({
          ...this.edited,
          cantidad: aux
        })
      }
    },
    cuentaId: {
      get () {
        return this.edited.cuenta_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          cuenta_id: value
        })
      }
    },
    precioId: {
      get () {
        return this.edited.precio_id
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          precio_id: value
        })
      }
    },
    glosa: {
      get () {
        return this.edited.glosa
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          glosa: value
        })
      }
    },
  },
  watch: {
    async dialog (newVal) {
      this.onLimpiar();
    },
    async fecha (newValue) {
      if (newValue) {
        this.periodo = await this.periodoFechaTo(newValue);
        const precio = await this.precioByVigencia(newValue);
        if(precio && precio.id > 0) {
          this.precioId = precio.id;
          this.precio = precio.subsidio;
        }
      } else {
        this.precio = 0;
        this.periodo = null;
        this.precioId = null;
      }
      this.cantidad = 0;
      this.importe = 0;
    },
    selectedId (newValue) {
      this.cuentaId = newValue
    },
  },
  methods: {
    ...mapActions('Bonos', ['onSave', 'onClearEdited', 'onClearSelected']),
    ...mapMutations('Bonos', ['setEdited']),
    async onLimpiar () {
      this.onClearEdited()
      this.onClearSelected()
      this.cuentaId = await this.selectedId;
      this.fecha = await this.$moment().format('YYYY-MM-DD');
      this.importe = 0;
    },
    onSubmit(event) {
      event.preventDefault();
      // Si ya estamos enviando, salimos de la función
      if (this.isSubmitting || !this.fecha) {
        return;
      }
      this.isSubmitting = true; // Establecer la bandera en true

      this.onSave().then(response => {
        this.onLimpiar();
        this.$store.dispatch('Transacciones/onFetch');
        this.$store.dispatch('Cuentas/onRefresh');
        this.dialog = false
      })
      .finally(() => {
        this.isSubmitting = false; // Restablecer la bandera a false al finalizar
      });
    },
    onClose (event) {
      event.preventDefault()
      this.dialog = false
    },
    handleInputImporte(newVal) {
      if(newVal >= 0) {
        this.cantidad = newVal / this.precio;
      }
    },
    handleInputKilos(newVal) {
      if(newVal >= 0) {
        this.importe = newVal * this.precio;
      }
    },
    onInput(newVal) {
      this.importe = newVal;
    }
  },
}
</script>
